import React from 'react'
import PropTypes from 'prop-types'
import { useViewport } from '@chilecompra/react-kit'
import { Switch } from '@chilecompra/react-kit/components'
import IconButton from '../Buttons/IconButton'
import { GridContainer, GridItem } from './ViewOption.styles'

/**
 * The ViewOption's component.
 */
const ViewOption = props => {
  const { checked, filter, margin, onChange, padding, viewOptions, setViewOptions } = props

  const {
    size: { isUpToSmall }
  } = useViewport()

  const handleShowOptions = type => () => {
    setViewOptions(
      viewOptions.map(option => ({
        disabled: option.type === type,
        type: option.type
      }))
    )
  }

  if (isUpToSmall) {
    return (
      <GridContainer alignItems="center" margin={margin} padding={padding}>
        <GridItem sm={6}>{!!filter && filter}</GridItem>
        <GridItem sm container justifyContent="flex-end">
          <Switch
            checked={checked}
            color="primary"
            labelLeft="CLP"
            labelRight="USD"
            margin="0 16px 0 0"
            onChange={onChange}
          />
          {viewOptions.map(option => (
            <IconButton
              disabled={option.disabled}
              key={option.type}
              onClick={handleShowOptions(option.type)}
              type={option.type}
              variant="outlined"
            />
          ))}
        </GridItem>
      </GridContainer>
    )
  }

  return (
    <GridContainer margin={margin} padding={padding}>
      <GridItem xs={12}>{!!filter && filter}</GridItem>
      <GridItem container justifyContent="center" xs={12}>
        <Switch
          checked={checked}
          color="primary"
          labelLeft="CLP"
          labelRight="USD"
          margin={isUpToSmall ? '0 16px 0 0' : '24px 0'}
          onChange={onChange}
        />
      </GridItem>
      <GridItem container justifyContent="center" xs={12}>
        {viewOptions.map(option => (
          <IconButton
            disabled={option.disabled}
            key={option.type}
            onClick={handleShowOptions(option.type)}
            type={option.type}
            variant="outlined"
          />
        ))}
      </GridItem>
    </GridContainer>
  )
}

ViewOption.defaultProps = {
  checked: false,
  filter: null,
  margin: 0,
  padding: 0,
  viewOptions: [],
  onChange: () => undefined,
  setViewOptions: () => undefined
}

ViewOption.propTypes = {
  checked: PropTypes.bool,
  filter: PropTypes.node,
  margin: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  padding: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  viewOptions: PropTypes.arrayOf(
    PropTypes.shape({
      disabled: PropTypes.bool,
      type: PropTypes.string
    })
  ),
  onChange: PropTypes.func,
  setViewOptions: PropTypes.func
}

export default ViewOption
